import type { Bonus } from '../types/offer'

export const bonuses: Bonus[] = [
  {
    number: '1',
    name: 'THE ARGENTINE FOOTBALL DICTIONARY',
    description: '100+ key concepts explained in simple, actionable language.',
    detail: "Reference guide you'll use forever",
    cover:
      'https://cdn.magicpatterns.com/uploads/fVtGKtTTYgKXnzhf3Qhrsv/BONO-1-BANGLADESH.png',
  },
  {
    number: '2',
    name: "THE CAPTAIN'S WORKBOOK",
    description: 'Interactive exercises to implement each concept immediately.',
    detail: '40+ pages of actionable worksheets',
    cover:
      'https://cdn.magicpatterns.com/uploads/4L7C3JuA1CRvXFozYjNsZR/BONO-2-BANGLADESH.png',
  },
  {
    number: '3',
    name: 'THE PRE-GAME FLOW',
    description:
      'Argentine success rituals adapted for modern work, business, and study.',
    detail: '15 proven daily routines that increase performance by 40%',
    cover:
      'https://cdn.magicpatterns.com/uploads/9VmtKLJZK9VnHpbP85ec5R/BONO-3-BANGLADESH.png',
  },
  {
    number: '4',
    name: '50 SOUTHERN SECRETS',
    description:
      'Direct quotes and stories from Argentine coaches, players, and entrepreneurs.',
    detail: 'The exact wisdom applied to Bangladesh reality',
    cover:
      'https://cdn.magicpatterns.com/uploads/iRwfEM3YRaw7caKmptBx2A/BONO-4-BANGLADESH.png',
  },
  {
    number: '5',
    name: 'THE NEGOTIATION CRIOLLA',
    description:
      'Negotiation framework used by the top 1% of Argentine professionals.',
    detail: 'Use in salary negotiations, client deals, or life decisions',
    cover:
      'https://cdn.magicpatterns.com/uploads/6ff7hPzZKjq2fzNfHnDXB6/BONO-5-BANGHADESH.png',
  },
]
